import { Component, OnDestroy } from "@angular/core";

// interfaces
import { AuthenticationService } from "src/app/auth/services/authentication.service";
import { User } from "src/app/models/Identity/user";
import { roleIdByName } from "src/app/auth/constants/auth.constants";
import { RolManagementService } from "src/app/auth/services/rol/rol-management.service";
import { Subscription } from "rxjs";

interface MenuItem {
  routerLink: string;
  icon: string;
  text: string;
  allowedRoles: roleIdByName[];
  isNewSectionDivision: boolean;
  subItems?: MenuItem[];
  expanded?: boolean;
}
@Component({
  selector: "app-menubar",
  templateUrl: "./menubar.component.html",
  styleUrls: ["./menubar.component.css"],
})
export class MenubarComponent implements OnDestroy {
  public isLogged: boolean = false;
  protected endLoading: boolean = false;
  public userLogged: User;
  private userSubscription: Subscription | null = null;

  protected menuItems: MenuItem[] = [
    {
      routerLink: "/home",
      icon: "home",
      isNewSectionDivision: false,
      text: "Inicio",
      allowedRoles: [
        roleIdByName.instructor,
        roleIdByName.jefeDesarrollo,
        roleIdByName.oficinasNacionales,
        roleIdByName.liderNacional,
      ],
    },
    // { routerLink: "/courses", icon: "library_books", text: "Cursos" },
    // { routerLink: "/myCourses", icon: "dashboard", text: "Mis cursos" },
    {
      routerLink: "/course-planning",
      icon: "edit_document",
      isNewSectionDivision: true,
      text: "Planeación",
      allowedRoles: [
        roleIdByName.instructor,
        roleIdByName.jefeDesarrollo,
        roleIdByName.oficinasNacionales,
        roleIdByName.liderNacional,
      ],
    },
    {
      routerLink: "/calendar",
      icon: "event",
      isNewSectionDivision: false,
      text: "Calendarización",
      allowedRoles: [
        roleIdByName.instructor,
        roleIdByName.jefeDesarrollo,
        roleIdByName.oficinasNacionales,
        roleIdByName.liderNacional,
      ],
    },

    {
      routerLink: "/myQrs",
      icon: "qr_code_scanner",
      isNewSectionDivision: false,
      text: "Mis QR",
      allowedRoles: [
        roleIdByName.instructor,
        roleIdByName.jefeDesarrollo,
        roleIdByName.oficinasNacionales,
        roleIdByName.liderNacional,
      ],
    },
    {
      routerLink: "/agenda",
      icon: "calendar_month",
      isNewSectionDivision: false,
      text: "Calendario nacional",
      allowedRoles: [
        roleIdByName.instructor,
        roleIdByName.jefeDesarrollo,
        roleIdByName.oficinasNacionales,
        roleIdByName.liderNacional,
      ],
    },
    {
      routerLink: "/report-assistance",
      icon: "checklist",
      isNewSectionDivision: true,
      text: "Asistencia",
      allowedRoles: [
        roleIdByName.instructor,
        roleIdByName.jefeDesarrollo,
        roleIdByName.oficinasNacionales,
        roleIdByName.liderNacional,
      ],
    },
    {
      routerLink: "/report-dc3",
      icon: "description",
      isNewSectionDivision: false,
      text: "DC-3",
      allowedRoles: [
        roleIdByName.instructor,
        roleIdByName.jefeDesarrollo,
        roleIdByName.oficinasNacionales,
        roleIdByName.liderNacional,
      ],
    },

    // {
    //   icon: "analytics",
    //   routerLink: "/reports",
    //   text: "Reportes",
    //   allowedRoles: [roleIdByName.instructor, roleIdByName.jefeDesarrollo],
    //   expanded: false,
    //   subItems: [
    //     {
    //       routerLink: "/report-assistance",
    //       icon: "checklist",
    //       text: "Asistencia",
    //       allowedRoles: [roleIdByName.instructor, roleIdByName.jefeDesarrollo],
    //     },
    //     {
    //       routerLink: "/report-dc3",
    //       icon: "description",
    //       text: "DC-3",
    //       allowedRoles: [roleIdByName.instructor, roleIdByName.jefeDesarrollo],
    //     },
    //     {
    //       routerLink: "/report-general",
    //       icon: "table_view",
    //       text: "General",
    //       allowedRoles: [roleIdByName.instructor, roleIdByName.jefeDesarrollo],
    //     },
    //   ],
    // },
    {
      icon: "analytics",
      routerLink: "/reports",
      text: "Reportes",
      isNewSectionDivision: true,
      allowedRoles: [
        roleIdByName.oficinasNacionales,
        roleIdByName.instructor,
        roleIdByName.jefeDesarrollo,
        roleIdByName.liderNacional,
      ],
      expanded: true,
      subItems: [
        {
          routerLink: "/report-general",
          icon: "verified",
          isNewSectionDivision: false,
          text: "Cumplimiento al plan anual",
          allowedRoles: [
            roleIdByName.instructor,
            roleIdByName.jefeDesarrollo,
            roleIdByName.oficinasNacionales,
            roleIdByName.liderNacional,
          ],
        },
        {
          routerLink: "/traininig-report",
          icon: "folder_open",
          isNewSectionDivision: true,
          text: "Expediente",
          allowedRoles: [
            roleIdByName.instructor,
            roleIdByName.jefeDesarrollo,
            roleIdByName.oficinasNacionales,
            roleIdByName.liderNacional,
          ],
        },
        {
          routerLink: "/deleted-sessions",
          icon: "delete",
          isNewSectionDivision: true,
          text: "Sesiones eliminadas",
          allowedRoles: [
            roleIdByName.instructor,
            roleIdByName.jefeDesarrollo,
            roleIdByName.oficinasNacionales,
            roleIdByName.liderNacional,
          ],
        },
        {
          routerLink: "/duplicate-attendees-report",
          icon: "auto_awesome_motion",
          isNewSectionDivision: true,
          text: "Duplicados",
          allowedRoles: [roleIdByName.oficinasNacionales],
        },
      ],
    },
    /*
    {
      routerLink: "/request-management",
      icon: "delete",
      isNewSectionDivision: true,
      text: "Sesiones eliminadas",
      allowedRoles: [roleIdByName.instructor, roleIdByName.jefeDesarrollo],
    },
    */
    {
      routerLink: "manageusers",
      icon: "supervisor_account",
      isNewSectionDivision: true,
      text: "Administración de usuarios",
      allowedRoles: [roleIdByName.oficinasNacionales],
    },
    {
      routerLink: "manageevents",
      icon: "event_note",
      isNewSectionDivision: true,
      text: "Administración de eventos",
      allowedRoles: [roleIdByName.oficinasNacionales],
    },
    {
      routerLink: "/catalog",
      icon: "library_books",
      isNewSectionDivision: false,
      text: "Administración de catálogos",
      allowedRoles: [roleIdByName.oficinasNacionales],
    },
    {
      routerLink: "/config",
      icon: "admin_panel_settings",
      isNewSectionDivision: false,
      text: "Configuraciones",
      allowedRoles: [roleIdByName.oficinasNacionales],
    },
  ];

  constructor(
    private authInternalService: AuthenticationService,
    private roleService: RolManagementService
  ) {
    this.userLogged = new User();
    if (this.userSubscription === null) {
      this.userSubscription = this.authInternalService.userObservable.subscribe(
        user => {
          if (user) {
            this.userLogged = user;
            this.endLoading = true;
          }
        }
      );
    }
  }

  ngOnDestroy(): void {
    this.userSubscription?.unsubscribe();
    this.userSubscription = null;
  }

  logout() {
    this.authInternalService.logout();
  }

  toggleSubMenu($event: Event, menuItem: MenuItem) {
    $event.preventDefault();
    menuItem.expanded = !menuItem.expanded;
  }

  isMenuItemAllowed(allowedRoles: number[]): boolean {
    return allowedRoles.includes(this.userLogged.fkIdRol);
  }
  get roleName() {
    return this.userLogged
      ? this.roleService.getRoleNameById(this.userLogged.fkIdRol, true)
      : "";
  }
}
